import React, { memo, useEffect } from "react";
import { Controller, useFieldArray } from "react-hook-form";
import RequiredTitle from "./RequiredTitle";

const MultipleEmailInputField = ({ input, control, error, defaultValue }) => {
  const {
    name,
    label,
    validation,
    defaultValues = defaultValue,
    alignment = {},
  } = input;
  const { sm = 12, md = 12, lg = 12 } = alignment;

  const { fields, append, remove, replace } = useFieldArray({
    control,
    name,
  });

  useEffect(() => {
    if (defaultValues?.length > 0) {
        replace(defaultValues);
    } else {
        replace([""]);
    }
  }, [defaultValues]);

  const addRow = () => {
    append("");
  };

  const removeRow = (index) => {
    if (fields.length > 1) {
      remove(index);
    }
  };

  return (
    <div className={`form-group mb-3 col-sm-${sm} col-md-${md} col-lg-${lg}`}>
      <RequiredTitle
        label={label}
        validation={validation}
      />
      <div>
        {fields.map((field, index) => (
          <Controller
            key={field.id}
            name={`${name}[${index}]`}
            control={control}
            rules={{
              pattern: {
                value: /^\S+@\S+\.\S+$/,
                message: "Invalid email address",
              },
              ...validation,
            }}
            render={({ field }) => (
              <div className="d-flex align-items-center mb-2">
                <input
                  type="email"
                  className="form-control"
                  placeholder="Enter email"
                  {...field}
                />
                <span
                  className="btn-icon-start-danger ms-2"
                  onClick={() => removeRow(index)}
                  style={{ cursor: "pointer" }}
                >
                  <i className="fa fa-trash color-info" />
                </span>
              </div>
            )}
          />
        ))}
        <span
          className="btn-icon-start-danger ms-1 mt-1"
          onClick={addRow}
          style={{ cursor: "pointer" }}
        >
          <i className="fa fa-plus color-info" />
        </span>
      </div>
      {error && <div className="invalid-feedback">{error}</div>}
    </div>
  );
};

export default memo(MultipleEmailInputField);
